import { render, staticRenderFns } from "./TourDiyConfig.vue?vue&type=template&id=185f77ab&"
import script from "./TourDiyConfig.vue?vue&type=script&lang=js&"
export * from "./TourDiyConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourDiyConfig.vue"
export default component.exports